export const AUTH_NAMESPACE_PATH = 'auth';
export const USER_NAMESPACE_PATH = 'user';
export const CIRCUITS_NAMESPACE_PATH = 'circuits';
export const HISTORY_NAMESPACE_PATH = 'history';
export const APP_NAMESPACE_PATH = 'app';
